import { BaseDashboardActionItem, LoadableTypography } from '@uplift/ui-v2';
import React from 'react';
import { DrawOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useHistory } from 'react-router';
import { ROUTING_CONFIG } from '@uplift/constants';
import { StatesLabel } from './components/StatesLabel';


type UnsignedCollaborativeAgreementsProps = {
  stateIds: string[];
};


export const UnsignedCollaborativeAgreements: React.VFC<UnsignedCollaborativeAgreementsProps> = (props) => {
  const history = useHistory();

  return (
    <BaseDashboardActionItem
      title={<Typography>Sign <b>{props.stateIds.length}</b> Collaborative Practice Agreements</Typography>}
      body={(
        <React.Suspense
          fallback={(
            <Box sx={{ mt: -1 }}>
              <LoadableTypography variant="body2" width="300px" />
            </Box>
          )}
        >
          <Typography variant="body2" sx={{ mt: -1 }}>
            <StatesLabel stateIds={props.stateIds} />
          </Typography>
        </React.Suspense>
      )}
      color="danger"
      icon={<DrawOutlined />}
      action={{
        handleClick: () => {
          history.push(ROUTING_CONFIG.documentsCenter);
        },
        text: 'Review & Sign'
      }}
    />
  );
};
